export const countPromptWords = (text = "") =>
  text
    .trim()
    .split(/\s+/)
    .filter(Boolean).length;
